module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("DFKk6"))).then(() => parcelRequire('d0iPb'));